import React from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestMassSalesOrderPickTicketGenerationRequest,
  RestPageListBean,
  RestReadRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import {
  PopupCustomerModule,
  PopupPickTicketModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class MassSalesOrderPickTicketGeneration extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass SalesOrder PickTicket Generation",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      error_list: [],
      alertMessage: [],
      alertType: "",
      massSODataList: [],
      selectedRowDataList: [],
      criteria: new SalesOrderSearchCriteria(),
      pageList: new RestPageListBean(),
      isMassSODataFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowPickTicketModule: false,
      moduleForPopup: [],
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      isShowWebFlag: true,
      disableCheckBox: false,
      isShowLookup: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    ModuleUtils.getSalesOrderStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    let listRequest = new RestMassSalesOrderPickTicketGenerationRequest();
    listRequest.criteria = criteria;
    listRequest.pageInput = pageInput;
    this.loadApprovedSalesOrderForMassPickTicketGenerartionList(listRequest);
  };
  loadApprovedSalesOrderForMassPickTicketGenerartionList = (listRequest) => {
    if (
      SecurityAccessManager.MassSalesOrderPickTicketGenerationMaintenance_IsAccessible()
    ) {
      SalesOrderService.getApprovedSalesOrderForMassPickTicketGenerartion(
        listRequest,
        this.loadApprovedSalesOrderForMassPickTicketGenerartionPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadApprovedSalesOrderForMassPickTicketGenerartionPageResponse = (
    response
  ) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.approvedSalesOrderPageListBean != null
    ) {
      let resultList = new Array();
      let disableCheckBox = false;
      let pageListBean = response.data.approvedSalesOrderPageListBean;
      if (
        !isEmptyArray(response.data.approvedSalesOrderPageListBean.infoBeans)
      ) {
        resultList = response.data.approvedSalesOrderPageListBean.infoBeans;
        let pageList = this.state.pageList;
        pageList.currentPage = pageListBean.currentPage;
        pageList.pageSize = pageListBean.pageSize;
        pageList.totalCount = pageListBean.totalCount;
        resultList.map((ln) => {
          if (!isEmptyArray(ln.pickTicketNumbers)) {
            disableCheckBox = true;
          }
        });
        this.setState({
          isMassSODataFound: true,
        });
        this.disable();
      } else {
        let errMsg = "No Data Found!";
        let error_list = [];
        error_list.push(errMsg);
        this.setState({
          alertMessage: error_list,
          alertType: "danger",
          isShowAlert: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
      this.setState({
        massSODataList: resultList,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        disableCheckBox: disableCheckBox,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new SalesOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.isWebOrderFlag = true;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
    });
    this.hideAlertCallBack();
  };
  reset = () => {
    let tempCriteria = new SalesOrderSearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    this.setState({
      criteria: tempCriteria,
      isMassSODataFound: false,
      massSODataList: new Array(),
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isShowWebFlag: true,
      isShowLookup: true,
      isDisabledFields: false,
    });
    this.hideAlertCallBack();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  viewCustomerModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewSalesModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewPickticketModule = (e,code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPickTicketModule: true,
        moduleForPopup: (
          <PopupPickTicketModule
            pickTicketCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  selectAll = (e) => {
    let list = this.state.massSODataList;
    list.map((line) => {
      if (!isEmptyArray(line.pickTicketNumbers)) {
        let errMsg = "PickTickets Already Generated";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      } else {
        line.isActive = true;
      }
    });
    this.setState({ selectedRowDataList: list });
  };
  unSelectAll = (e) => {
    let list = this.state.massSODataList;
    list.map((line, i) => {
      line.isActive = false;
    });
    this.setState({ selectedRowDataList: [] });
  };
  onSelectedChange = (e, rowData) => {
    rowData.isActive = e.target.value;
    if (!isEmptyArray(rowData.pickTicketNumbers)) {
      let errMsg = "PickTickets Already Generated";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      if (rowData.isActive === true) {
        let selectedLine = this.state.selectedRowDataList;
        selectedLine.push(rowData);
        this.setState({ selectedRowDataList: selectedLine });
      } else {
        let checkLines = this.state.selectedRowDataList;
        let selectedLine = [];
        for (let line of checkLines) {
          if (line.isActive != rowData.isActive) {
            selectedLine.push(line);
            this.setState({ selectedRowDataList: selectedLine });
          } else if (this.state.selectedRowDataList.length == 1) {
            this.setState({ selectedRowDataList: [] });
          }
        }
      }
    }
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let tempCriteria = this.state.criteria;
      tempCriteria.customerCode = "";
      tempCriteria.customerName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempCriteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.state.showAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  displayAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: isShowAutoCompleteList });
  };
  generatePickTicket = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating PickTicket...",
    });
    let list = this.state.selectedRowDataList;
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    let salesOrderNumbers = [];
    list.map((soNubers) => {
      salesOrderNumbers.push(soNubers.salesOrderNumber);
    });
    criteria.salesOrderNumbers = salesOrderNumbers;
    if (!isEmptyArray(list)) {
      this.hideAlertCallBack();
      this.generatePickTicketGeneration(criteria);
    } else {
      let errMsg = "Select the Line";
      let error_list = [];
      error_list.push(errMsg);
      this.setState({
        alertMessage: error_list,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generatePickTicketGeneration = (criteria) => {
    if (
      SecurityAccessManager.MassSalesOrderPickTicketGenerationMaintenance_IsAccessible()
    ) {
      SalesOrderService.generateMassPickTicketGenerartion(
        criteria,
        this.loadgeneratePickTicketGenerationResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadgeneratePickTicketGenerationResponse = (response) => {
    this.handleresponse(response.data);
    this.setState({
      selectedRowDataList: new Array(),
    });
    this.loadPage();
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null) {
      let customerData = response.data.customer;
      if (!isEmptyArray(customerData)) {
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  onCheckBoxChange = (e) => {
    let tempData = this.state.criteria;
    tempData["isWebOrderFlag"] = e.target.value;
    this.setState({
      criteria: tempData,
      isShowWebFlag: false,
    });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  getCaption = (status)=>{
    return ModuleUtils.getSalesOrderStatusCaption(status)
  }
  soPickticketColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.onSelectedChange,
          null
        )
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
        .setDisabled(this.state.disableCheckBox)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "SalesOrderNumber#",
          "salesOrderNumber",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true,false,this.viewSalesModule,null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Web S.O", "webSalesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TargetWebSite", "targetWebSite", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("WebExportType", "webChanneledType", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "PickTickets#",
          "pickTicketNumbers",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true,false,this.viewPickticketModule,null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "PickTicketDate#",
          "pickTicketDate",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          "Customer#",
          "customerCode",
          true
        )
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true,false,this.viewCustomerModule,null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true,this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O#StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("S.O#StopDate", "salesOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
   
  
    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails("", "isActive", 0, false, null, false, null, "2em")
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.onSelectedChange
        )
        .setDisabled(this.state.disableCheckBox)
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "S.O#",
        "salesOrderNumber",
        0,
        true,
        this.viewSalesModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Web S.O#",
        "webSalesOrderNumber"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "TargetWebSite",
        "targetWebSite"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "webExportType",
        "webChanneledType"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickTickets#",
        "pickTicketNumbers",
        0,
        true,
        this.viewPickticketModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PickTicketDate",
        "pickTicketDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.viewCustomerModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerName",
        "customerName",
        0,
        false,
        null,
        false,
        null,
        "24em",
        "50%"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "status",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%", //max-width
        true,
        ModuleUtils.getSalesOrderStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "S.O#StartDate",
        "salesOrderStartDate"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "S.O#StopDate",
        "salesOrderStopDate"
      )
    );
    return columnList;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowPickTicketModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  render() {
    let massSODataList = this.state.massSODataList;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.reset}
        />
        <CriteriaView
          {...this.state}
          onCustomerCodeChange={this.onCustomerCodeChange}
          onCheckBoxChange={this.onCheckBoxChange}
          selectAll={this.selectAll}
          unSelectAll={this.unSelectAll}
          generatePickTicket={this.generatePickTicket}
          displayAutoCompleteList={this.displayAutoCompleteList}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
        />
        {this.state.isMassSODataFound && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isMassSODataFound && (
          <div className="div_default">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={massSODataList}
            /> */}
            <CustomTable
columns={this.soPickticketColumns()}
data={massSODataList}
label={"Sales Pickticket List"}
            />
          </div>
        )}
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPickTicketModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}

export function CriteriaView(props) {
  const onCustomerCodeChange = (e) => props.onCustomerCodeChange(e);
  const onCheckBoxChange = (e) => props.onCheckBoxChange(e);
  const selectAll = (e) => {
    if (e.detail <= 1) props.selectAll();
  };
  const unSelectAll = (e) => {
    if (e.detail <= 1) props.unSelectAll();
  };
  const generatePickTicket = (e) => {
    if (e.detail <= 1) props.generatePickTicket();
  };
  const displayAutoCompleteList = (showAutoCompleteCustomerList) => {
    props.displayAutoCompleteList(showAutoCompleteCustomerList);
  };
  const customerCodeEnterKeyEventHandler = (e) =>
    props.customerCodeEnterKeyEventHandler(e);
  let criteria = props.criteria;
  if (props.isShowWebFlag === true) {
    criteria.isWebOrderFlag = true;
  }
  const customerCodeRef = props.customerCodeRef;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onCustomerCodeChange}
            placeholder="Customer"
            ref={customerCodeRef}
            name="customerCode"
            value={criteria.customerCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onCustomerCodeChange}
            value={criteria.customerName}
            readOnly={true}
          />
        </Col>
        <Col md={1}>
          <InputCheckbox
            type="checkbox"
            name="isWebOrderFlag"
            onChange={onCheckBoxChange}
            checked={criteria.isWebOrderFlag}
            disabled={props.isDisabledFields}
          />
        </Col>
        <Col md={0.9}>
          <FormLabel>isWebOrder</FormLabel>
        </Col>
      </Row>
      {props.isMassSODataFound && (
        <Row>
          <Col sm="1">
            <Button
              size="sm"
              variant="secondry"
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => selectAll(e)}
            >
              SelectAll
            </Button>
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              variant="secondry"
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => unSelectAll(e)}
            >
              UnselectAll
            </Button>
          </Col>
          <Col sm="1">
            <Button
              size="sm"
              variant="secondry"
              id="fabric_Add_Button"
              className="enterFocus"
              onClick={(e) => generatePickTicket(e)}
            >
              PickTicket
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
}
function MassSalesOrderPickTicketGenerationModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <MassSalesOrderPickTicketGeneration {...props} name="" /> <br />
    </div>
  );
}

export default MassSalesOrderPickTicketGenerationModule;
